<template>
  <el-dialog
    :title="$t('add_competitor')"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="40%"
  >
    <el-form
      :model="addCompetitorForm"
      :rules="rules"
      ref="addCompetitorForm"
      label-width="165px"
      label-position="top"
    >
      <el-form-item :label="$t('url_of_competitor')" prop="url">
        <el-input
          v-model="addCompetitorForm.url"
          clearable
          :disabled="disabled()"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('competitor_group')">
        <el-select
          v-model="addCompetitorForm.competitorType"
          clearable
          v-if="studyLinks.competitors.hasOwnProperty('create')"
        >
          <el-option
            v-for="type in studyLinks.competitors.create.form[1].options"
            :label="$t(type.toLowerCase())"
            :value="type"
            :key="type"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-tooltip :content="$t('shopping_source_tooltip')" placement="bottom">
        <el-form-item :label="$t('shopping_source')" prop="shoppingSource">
          <el-input
            v-model="addCompetitorForm.shoppingSource"
            :placeholder="shoppingPlaceholder"
            clearable
          ></el-input>
        </el-form-item>
      </el-tooltip>
      <el-form-item>
        <el-button
          type="success"
          :disabled="!isFormSubmitable"
          @click="submit(addCompetitorForm)"
          >{{ $t("confirm") }}</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    competitorUrl: String,
    dialogVisible: Boolean,
    studyLinks: Object,
  },
  data() {
    return {
      addCompetitorForm: {
        url: null,
        competitorType: "DIRECT",
        shoppingSource: ""
      },
      shoppingPlaceholder: "",
      rules: {
        url: [
          {
            required: true,
            message: this.$t("url_mandatory"),
            trigger: "change",
          }
        ],
        shoppingSource: [
          {
            required: true,
            message: this.$t("shopping_source_mandatory"),
            trigger: "change",
          }
        ]
      }
    };
  },
  computed: {
    isFormSubmitable() {
      if (this.addCompetitorForm?.url?.trim() && this.addCompetitorForm?.shoppingSource?.trim()) {
        return true;
      }
      return false;
    },
  },
  methods: {
    submit(form) {
      this.$emit("create-competitor", form);
    },
    disabled() {
      if (this.competitorUrl != null) {
        this.addCompetitorForm.url = this.competitorUrl;
        return true;
      } else return false;
    },
    handleClose() {
      this.$emit("close-dialog");
    },
    extractDomainName(urlString) {
      if (!urlString) return "";
      let hostname;
      try {
        const fullUrl = urlString.startsWith('http') ? urlString : `http://${urlString}`;
        hostname = new URL(fullUrl).hostname;
      } catch (e) {
        return "";
      }
      const parts = hostname.split('.');
      if (parts.length > 2 && parts[0] === 'www') {
        return parts[1];
      }
      return parts[0];
    }
  },
  watch: {
    'addCompetitorForm.url'(newUrl) {
      if (newUrl) {
        this.shoppingPlaceholder = this.extractDomainName(newUrl);
      } else {
        this.shoppingPlaceholder = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button {
  float: right;
}
.el-select {
  width: 100%;
}
</style>

<i18n>
{
  "en": {
    "add_competitor": "Add competitor",
    "competitor_group": "Group of competitors",
    "confirm": "Confirm",
    "direct": "Direct",
    "indirect": "Indirect",
    "others": "Others",
    "url_of_competitor": "URL of the competitor",
    "shopping_source": "Brand name",
    "shopping_source_tooltip": "Used to correctly identify the brand in Shopping results and by LLMs.",
    "url_mandatory": "Please fill in an url",
    "shopping_source_mandatory": "Please fill in a brand name"
  },
  "fr": {
    "add_competitor": "Ajouter un concurrent",
    "competitor_group": "Groupe de concurrents",
    "confirm": "Valider",
    "direct": "Direct",
    "indirect": "Indirect",
    "others": "Autres",
    "url_of_competitor": "URL de votre concurrent",
    "shopping_source": "Nom de marque",
    "shopping_source_tooltip": "Sert à identifier la marque dans les résultats Shopping et par les LLMs.",
    "url_mandatory": "Veuillez saisir une url",
    "shopping_source_mandatory": "Veuillez saisir un nom de marque"
  },
  "de": {
    "add_competitor": "Fügen Sie einen Konkurrenten hinzu",
    "competitor_group": "Gruppe von Konkurrenten",
    "confirm": "Bestätigen",
    "direct": "Direkte",
    "indirect": "Indirekt",
    "others": "Andere",
    "url_of_competitor": "Die URL Ihres Konkurrenten",
    "shopping_source": "Markenname",
    "shopping_source_tooltip": "Dient dazu, die Marke in Shopping-Ergebnissen und von LLMs korrekt zu erkennen.",
    "url_mandatory": "Bitte geben Sie eine URL ein",
    "shopping_source_mandatory": "Bitte geben Sie einen Markennamen ein"
  }
}
</i18n>
